import { render, staticRenderFns } from "./CourseListPage.vue?vue&type=template&id=1242c4d8&scoped=true&"
import script from "./CourseListPage.vue?vue&type=script&lang=js&"
export * from "./CourseListPage.vue?vue&type=script&lang=js&"
import style0 from "./CourseListPage.vue?vue&type=style&index=0&id=1242c4d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1242c4d8",
  null
  
)

export default component.exports